 // Alteração no modelo de exibição do versionamento do front do back e da base de dados
 // Retorno no formato de data
 // retornos considerados
 // Front informado em variável
 // back informado em variável
 // base de dados  gravado em tabela do banco

//export const VERSION_FRONT = '2025-09-11T16:00:00';

export const VERSION_FRONT = document.lastModified;